module.exports = __webpack_public_path__ + "static/media/database.eae02d72.svg";